import { states } from "../../constants/states";
import { sortByKey } from "../sortByKey";

// Continents appended below the U.S. states in the State/Country dropdowns
export const continents = [
  "Africa",
  "Antarctica",
  "Asia",
  "Australia / Oceania",
  "Europe",
  "North America",
  "South America",
];

// Non-selectable divider shown between the states and the continents.
// searchLabel is empty so it is hidden while the user is filtering.
export const continentsSeparatorOption = {
  value: "__continents_separator__",
  label: "──────────────── Continents ────────────────",
  disabled: true,
  searchLabel: "",
};

// Sorted dropdown options: U.S. states (alphabetical) → separator → continents (alphabetical)
export const sortedStates = [
  ...sortByKey(states),
  continentsSeparatorOption,
  ...sortByKey(continents),
];
export const sortedMaritalStatusOptions = [
  { value: "1", label: "Single/Divorced" },
  { value: "3", label: "In Relationship" },
  { value: "2", label: "Married" },
  { value: "5", label: "Separated" },
  { value: "6", label: "Remarried" },
  { value: "4", label: "Widowed" },
];
export const sortedGenderOptions = [
  { value: "1", label: "M" },
  { value: "2", label: "F" },
  { value: "4", label: "Other" },
];
export const sortedLivingDeceasedOptions = [
  { value: "1", label: "Living" },
  { value: "2", label: "Deceased" },
];
export const sortedCellTypeOptions = sortByKey([
  { value: "1", label: "iPhone" },
  { value: "2", label: "Android" },
  { value: "3", label: "No Phone" },
], 'label');
export const multipleBirthsOptions = [
  { value: "2", label: "Twin (2)" },
  { value: "3", label: "Triplet (3)" },
  { value: "4", label: "Quadruplet (4)" },
  { value: "5", label: "Quintuplet (5)" },
  { value: "6", label: "Sextuplet (6)" },
  { value: "7", label: "Septuplet (7)" },
  { value: "8", label: "Octuplet (8)" },
  { value: "9", label: "Nuntuplet (9)" },
];
export const sortedDivorceOptions = sortByKey([
  { value: "1", label: "Yes" },
  { value: "2", label: "No" },
], 'label');

/** In Relationship (3) and Widowed (4) do not require divorce or wedding anniversary. */
export const isRelationshipOrWidowedMaritalStatus = (maritalStatus) => {
  const status = Number(maritalStatus);
  return status === 3 || status === 4;
};

/** In Relationship (3) — wedding anniversary is not applicable and must not be sent. */
export const isInRelationshipMaritalStatus = (maritalStatus) =>
  Number(maritalStatus) === 3;